<template>
    <transition
        name="slide-bottom"
        mode="out-in"
    >
        <div
            v-if="isSocketOffline"
            class="socket-notification notification-handler offline__notification-handler"
        >
            <CloudOffIcon class="icon" />
            {{ $t('common.socketOffline') }}
        </div>
    </transition>
</template>

<script>
import { CloudOffIcon } from 'vue-feather-icons'

export default {
    components: {
        CloudOffIcon,
    },
    computed: {
        isSocketOffline () {
            return this.$store.getters['sdkGlobalState/isSocketOffline']
        },
    }
}
</script>
<style lang="scss" scoped>
.notification-handler {
    @apply flex items-center justify-center;
    width: auto;
    right: 0;
    top: auto;
    left: auto;
    bottom: 0;
    border-top-left-radius: 10px;
    z-index: 2000;
    position: fixed;
    padding: 3px 8px;
    color: white;
    font-weight: 600;
    opacity: 1;

    .icon {
        margin: 0 10px;
    }

    @apply py-1;
}

.offline__notification-handler {
    @apply bg-red-500;
}

.online__notification-handler {
    @apply bg-green-400;
}
</style>

<style lang="scss">
.slide-bottom-enter,
.slide-bottom-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.slide-bottom-enter-active {
    transition: all 0.3s ease;
}

.slide-bottom-leave-active {
    transition: all 0.5s ease;
}

.slide-top-enter,
.slide-top-leave-to {
    transform: translateY(-30px);
}

.slide-top-enter-active {
    transition: all 0.3s ease;
}

.slide-top-leave-active {
    transition: all 0.5s ease;
}
</style>
